import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';
import {
  GetTeamWonTitleResponse,
  PostTeamWonTitleResponse,
  GetTeamWonTitleByIdResponse,
  PutTeamWonTitleResponse,
} from '../response/won-title';

export class WonTitleService {
  static getWonTitles(params?: QueryParams) {
    return apiClient.get<GetTeamWonTitleResponse>(buildApiUrl('/api/v1/team/won-title'), params);
  }

  static postWonTitle(data: any) {
    return apiClient.post<PostTeamWonTitleResponse>(buildApiUrl('/api/v1/team/won-title'), data);
  }

  static getWonTitleById(id: string) {
    return apiClient.get<GetTeamWonTitleByIdResponse>(buildApiUrl('/api/v1/team/won-title/:id', { id }), undefined);
  }

  static putWonTitle(id: string, data: any) {
    return apiClient.update<PutTeamWonTitleResponse>(buildApiUrl('/api/v1/team/won-title/:id', { id }), data);
  }

  static deleteWonTitle(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/team/won-title/:id', { id }), undefined);
  }
}
